import { RouteObject } from "react-router-dom";
import OwnerLayout from "../../layout/OwnerLayout";
import OwnerDashboard from "../../pages/Owner/Dashboard";
import CommonCarriers from "../../pages/Owner/CommonCarriers";
import AddOrderPage from "../../pages/Owner/AddOrder";
import ManageOrders from "../../pages/Owner/ManageOrders";
import OrderDetailsPage from "../../pages/Owner/OrderDetails";
import ProfilePage from "../../pages/Owner/Profile";
import EditProfile from "../../pages/Owner/Profile/EditProfile";
import NotifsPage from "../../pages/Owner/Notifs";
import MapTestPage from "../../pages/Owner/MapTestPage";
import WalletPage from "../../pages/Owner/Wallet";
import SettingsPage from "../../pages/Owner/Settings";
import ChangePasswordPage from "../../pages/Owner/ChangePass";
import OwnerChangeMobilePage from "../../pages/Owner/ChangeMobile";
import TenderOffer from "../../pages/Owner/TenderOffer";
import SuportPage from "../../pages/Owner/SuportPage";
import BolsTrackingPage from "../../pages/Owner/BolsTracking";
import SendTicketPage from "../../pages/Driver/SendTicketPage";
import TicketDetailsPage from "../../pages/Driver/SendTicketPage/TicketDetailsPage";
import BolsHistories from "../../pages/Owner/BolsHistories";
import SurveyPage from "../../pages/Driver/SurveyPage";

import CommunicateCompanies from "../../pages/CommunicateCompanies";
import NotFound from "../../pages/NotFound";

const ownerRoutes: RouteObject[] = [
  {
    path: "/owner",
    element: <OwnerLayout />,
    children: [
      {
        path: "map",
        element: <MapTestPage />,
      },
      {
        path: "dashboard",
        element: <OwnerDashboard />,
      },
      {
        path: "add-order",
        element: <AddOrderPage />,
      },
      {
        path: "common-carriers",
        element: <CommonCarriers />,
      },
      {
        path: "manage-orders",
        element: <ManageOrders />,
      },
      {
        path: "manage-orders/:orderId",
        element: <OrderDetailsPage />,
      },
      {
        path: "profile",
        element: <ProfilePage />,
      },
      {
        path: "edit-profile",
        element: <EditProfile />,
      },
      {
        path: "notifs",
        element: <NotifsPage />,
      },
      {
        path: "wallet",
        element: <WalletPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
      {
        path: "change-password",
        element: <ChangePasswordPage />,
      },
      {
        path: "change-mobile",
        element: <OwnerChangeMobilePage />,
      },
      {
        path: "tenderoffers",
        element: <TenderOffer />,
      },
      {
        path: "ticket",
        element: <SuportPage />,
      },
      {
        path: "ticket/new-ticket",
        element: <SendTicketPage />,
      },
      {
        path: "ticket/:ticketId",
        element: <TicketDetailsPage />,
      },
      {
        path: "bols-histories",
        element: <BolsHistories />,
      },
      {
        path: "bills-tracking",
        element: <BolsTrackingPage />,
      },
      {
        path: "survey",
        element: <SurveyPage />,
      },
      {
        path: "communicate-companies",
        element: <CommunicateCompanies />,
      },
    ],
  },
  {
    path: "/owner/",
    element: <NotFound />,
  },
];

export default ownerRoutes;
